import React, { useContext } from "react";
import { TableContext } from "./ListTable";
import ListRowChip from "./ListRowChip";
import Cell from "@reactComponents/lds/table/Cell";
import Row from "@reactComponents/lds/table/Row";
import CheckboxItem, { CHECKBOX_STATES } from "@reactComponents/lds/selection_controls/CheckboxItem";

function ListTableRow({ list }) {
  const { editable, onListSelected, selectedRows, entriesAlignment } = useContext(TableContext);

  let editColumn = null;
  let isRowSelected = false;

  if (editable) {
    isRowSelected = selectedRows.has(list.id);

    editColumn = (
      <Cell justify="center">
        <CheckboxItem
          id={list.id}
          selection={isRowSelected ? CHECKBOX_STATES.selected : CHECKBOX_STATES.unselected}
          onClick={() => onListSelected(list)}
        />
      </Cell>
    );
  }

  return (
    <Row selected={isRowSelected}>
      <Cell width="100%">
        <div className="name-column">
          <ListRowChip label={list.type_ref} />
          <a href={`/lists/${list.id}`} className="name-column-text">
            {list.name}
          </a>
        </div>
      </Cell>
      <Cell justify={entriesAlignment}>{list.entity_count}</Cell>
      {editColumn}
    </Row>
  );
}

export default ListTableRow;
